import { BadgeVariant } from '@tallo/design-system';

import { TeamSubject } from '../../dtos/property-team.dto.interface';

export interface TeamRoleBadge {
  label: string;
  variant: BadgeVariant;
}

export interface TeamRailSection {
  id: string;
  label: string;
  /** Left out while the section is still loading, so the rail shows no count rather than a wrong one */
  count?: number;
}

/** One colour per role, so a person in two roles reads the same on every row they appear in */
export const teamRoleBadges = {
  manager: { label: 'Manager', variant: 'orange' },
  collaborator: { label: 'Collaborator', variant: 'grey' },
  showingAgent: { label: 'Showing agent', variant: 'blue' },
} satisfies Record<string, TeamRoleBadge>;

/** What the copy calls the place a team works */
export function subjectNoun(subject: TeamSubject): 'unit' | 'building' {
  return subject.kind === 'building' ? 'building' : 'unit';
}
